import React from "react";

const Radios = ({ label, reqd, data, value, click }) => {
  const labels = data.map((item, index) => {
    return (
      <label key={index} className={!item.label ? "hidden" : ""}>
        <input
          type="radio"
          name={item.name}
          value={item.val}
          defaultChecked={item.val === value}
          onClick={(e) => click(item.name, e.target.value)}
        />
        <span>{item.label}</span>
      </label>
    );
  });

  return (
    <div>
      <label>
        {label} <span className="reqd">{reqd ? "*" : " "}</span>
      </label>
      <div>{labels}</div>
    </div>
  );
};

export default Radios;
